import React from 'react';
import { Card, Heading2, Stack, P, CTAButton } from '@ovotech/element-v4';
import { BANNER_CTA_CLICKED } from '@/src/constants/analytics';
import styles from './ChangedMindAboutTakingOVOSection.module.css';
import { useAccountContext, useCustomerContext } from '@ovotech/ui-tools';
import { redirectToQS } from '@/src/pages/MovingHome/utils/redirectToQS';

export function ChangedMindAboutTakingOVOSection() {
  const { accountId } = useAccountContext();
  const { customerId } = useCustomerContext();

  return (
    <Card>
      <Stack spaceBetween={[4, 5]}>
        <Heading2 className={styles.heading}>
          Changed your mind about taking OVO with you?
        </Heading2>
        <Stack spaceBetween={[2, 3]}>
          <P>
            There’s still time to take us with you and keep all your OVO perks
            like prize draws, Beyond and more. Find an energy tariff that works
            better for you. We'll help you save energy and money, as we cut our
            collective carbon footprint together.
          </P>
          <P>
            By clicking "Get a quote" you agree we can use your new address to
            look up the meter details of your home and who your current supplier
            is, using standard industry databases.
          </P>
        </Stack>

        <CTAButton
          className={styles.cta}
          data-event-name={BANNER_CTA_CLICKED}
          data-event-props={JSON.stringify({
            bannerId: 'moveOutInProgress',
            ctaName: 'Get a quote',
          })}
          onClick={() => {
            redirectToQS(accountId, customerId);
          }}
        >
          Get a quote
        </CTAButton>
      </Stack>
    </Card>
  );
}
